import React from "react";

interface BoxProps {
    title: string;
    points: string[];
    bgColor: string;
    textColor: string;
}

const Box: React.FC<BoxProps> = ({ title, points, bgColor, textColor }) => {
    return (
        <div className={`  p-5 lg:w-64 w-full rounded-lg mt-4 bg-${bgColor}  focus:outline-none`}>
            <p className={`text-2xl font-semibold mb-2 text-${textColor}`}>{title}</p>
            <ul>
                {points.map((point, index) => (
                    <li key={index} className={`mb-1 text-base text-${textColor}`}>
                        {point}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Box;
